import 'flowbite';
import './dark-mode';
import './current-year';
import "./sidebar";
import "./charts";
import "./api";
import "./navbar";
import 'htmx.org';
import 'htmx-ext-head-support';
import 'htmx-ext-preload';
import _hyperscript from 'hyperscript.org';

import ApexCharts from 'apexcharts';
window.ApexCharts = ApexCharts;
window.htmx = require('htmx.org');

_hyperscript.config.hideShowStrategies = {
    twDisplay: function (op, element, arg) {
        if (op === "toggle") {
            if (element.classList.contains("hidden")) {
                _hyperscript.config.hideShowStrategies.twDisplay("show", element, arg);
            } else {
                _hyperscript.config.hideShowStrategies.twDisplay("hide", element, arg);
            }
        } else if (op === "hide") {
            element.classList.add('hidden');
        } else {
            element.classList.remove('hidden');
        }
    },

    twVisibility: function (op, element, arg) {
        if (op === "toggle") {
            if (element.classList.contains("invisible")) {
                _hyperscript.config.hideShowStrategies.twVisibility("show", element, arg);
            } else {
                _hyperscript.config.hideShowStrategies.twVisibility("hide", element, arg);
            }
        } else if (op === "hide") {
            element.classList.add('invisible');
        } else {
            element.classList.remove('invisible');
        }
    },

    twOpacity: function (op, element, arg) {
        if (op === "toggle") {
            if (element.classList.contains("opacity-0")) {
                _hyperscript.config.hideShowStrategies.twOpacity("show", element, arg);
            } else {
                _hyperscript.config.hideShowStrategies.twOpacity("hide", element, arg);
            }
        } else if (op === "hide") {
            element.classList.add('opacity-0');
        } else {
            element.classList.remove('opacity-0');
        }
    }
};

_hyperscript.config.defaultHideShowStrategy = 'twDisplay';
_hyperscript.browserInit();